(function() {
  'use strict';

  const STORAGE_KEY = 'ao_wishlist';

  const WishlistManager = {
    getItems() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch {
        return [];
      }
    },

    saveItems(items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    },

    addItem(product) {
      const items = this.getItems();
      if (!items.find(item => item.id === product.id)) {
        items.push(product);
        this.saveItems(items);
      }
    },

    removeItem(productId) {
      const items = this.getItems().filter(item => item.id !== productId);
      this.saveItems(items);
    },

    hasItem(productId) {
      return this.getItems().some(item => item.id === productId);
    },

    toggle(product) {
      if (this.hasItem(product.id)) {
        this.removeItem(product.id);
        return false;
      } else {
        this.addItem(product);
        return true;
      }
    }
  };

  // Heart button on PDP
  function initHeartButton() {
    const btn = document.getElementById('wishlist-toggle');
    if (!btn) return;

    const productId = btn.dataset.productId;

    if (WishlistManager.hasItem(productId)) {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        url: btn.dataset.productUrl,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        variantId: btn.dataset.variantId
      };

      const added = WishlistManager.toggle(product);
      btn.classList.toggle('is-active', added);
      updateDrawerCount();
      openDrawer();
    });
  }

  // Wishlist drawer
  function initDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;

    // Open drawer from nav link
    document.querySelectorAll('[data-wishlist-nav]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    // Close drawer
    drawer.querySelector('.wishlist-drawer__close')?.addEventListener('click', closeDrawer);
    drawer.querySelector('.wishlist-drawer__overlay')?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  function openDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    renderDrawerItems();
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderDrawerItems() {
    const container = document.getElementById('wishlist-items');
    const emptyState = document.getElementById('wishlist-empty');
    if (!container || !emptyState) return;

    const items = WishlistManager.getItems();

    if (items.length === 0) {
      container.innerHTML = '';
      emptyState.style.display = 'flex';
      return;
    }

    emptyState.style.display = 'none';

    container.innerHTML = items.map(function(item) {
      return '<div class="wishlist-item" data-product-id="' + item.id + '">' +
        '<a href="' + item.url + '" class="wishlist-item__image">' +
          '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '</a>' +
        '<div class="wishlist-item__info">' +
          '<a href="' + item.url + '" class="wishlist-item__title">' + item.title + '</a>' +
          '<p class="wishlist-item__price">' + item.price + '</p>' +
          '<button type="button" class="wishlist-item__remove" data-product-id="' + item.id + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    // Remove buttons
    container.querySelectorAll('.wishlist-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const productId = btn.dataset.productId;
        WishlistManager.removeItem(productId);
        renderDrawerItems();
        updateDrawerCount();

        // Update heart button on PDP if same product
        const heartBtn = document.getElementById('wishlist-toggle');
        if (heartBtn && heartBtn.dataset.productId === productId) {
          heartBtn.classList.remove('is-active');
        }
      });
    });

  }

  function updateDrawerCount() {
    const count = WishlistManager.getItems().length;
    document.querySelectorAll('.wishlist-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', function() {
    initHeartButton();
    initDrawer();
    updateDrawerCount();
  });
})();
